import { MessageCenterTypes } from './MessageCenterTypes';

export interface MessageCenterState {
  messageCenterVisible: boolean;
}

const initialState: MessageCenterState = {
  messageCenterVisible: false,
};

// biome-ignore lint/suspicious/noExplicitAny: TODO: fix
const MessageCenterReducer = (state = initialState, { type, payload }: any): MessageCenterState => {
  switch (type) {
    case MessageCenterTypes.SET_OPEN: {
      return {
        ...state,
        messageCenterVisible: payload,
      };
    }

    default:
      return state;
  }
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default MessageCenterReducer;
